import { UpgradeCtaContextType } from "@contexts/CallToActionContext";

export type PricingTierContentType = {
    title: string;
};

export type PricingTierType = "free" | "pro";

export const PricingTierContent: Record<PricingTierType, PricingTierContentType> = {
    free: {
        title: "Free",
    },
    pro: {
        title: "Pro",
    },
};

export const UPGRADE_CONTENT: Record<UpgradeCtaContextType, { header: string }> = {
    default: {
        header: "Upgrade to Pro",
    },
    onboarding: {
        header: "Select your plan",
    },
    onboardingBlockedFlow: {
        header: "Select your plan",
    },
    readOnlyWidget: {
        header: "Use your favorite tools",
    },
    multipleCalendars: {
        header: "Do more with multiple calendars",
    },
    unlimitedVideoChat: {
        header: "Video chat for as long as you want",
    },
    unlimitedSounds: {
        header: "Unlock all ambient sounds",
    },
    notes: {
        header: "Jot down notes effortlessly",
    },
    pomodoroSounds: {
        header: "Unlock all timer alarm sounds",
    },
    productivityReports: {
        header: "Keep track of your productivity",
    },
    spaces: {
        header: "Unlock this pro space",
    },
    tags: {
        header: "Multiple tags for all areas of life",
    },
    projects: {
        header: "Unlock Projects",
    },
    planner: {
        header: "Unlock Planner",
    },
    taskTimer: {
        header: "Unlock Task Countdowns",
    },
};
